var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1767929689193,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2994,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.496 316.688H736V720H330.496V316.688z m88 87.536H648V632.48H418.496V404.224z",
    fill: "#95EAFF",
    "p-id": 2995
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.192 448H304a16 16 0 0 0 0 32h88.192a16 16 0 0 0 0-32zM640 480h88.192a16 16 0 0 0 0-32H640a16 16 0 0 0 0 32zM392.192 544H304a16 16 0 0 0 0 32h88.192a16 16 0 0 0 0-32zM728.192 544H640a16 16 0 0 0 0 32h88.192a16 16 0 0 0 0-32z",
    fill: "#0F13AE",
    "p-id": 2996
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336 112H176a16 16 0 0 0 0 32h144v96a16 16 0 0 0 32 0V128a16 16 0 0 0-16-16zM336 768a16 16 0 0 0-16 16v96h-144a16 16 0 0 0 0 32h160a16 16 0 0 0 16-16v-112a16 16 0 0 0-16-16zM688 256a16 16 0 0 0 16-16V144h144a16 16 0 0 0 0-32H688a16 16 0 0 0-16 16v112a16 16 0 0 0 16 16zM848 880h-144v-96a16 16 0 0 0-32 0v112a16 16 0 0 0 16 16h160a16 16 0 0 0 0-32zM630.592 379.888H528V304a16 16 0 0 0-32 0v75.888h-102.592a16 16 0 0 0-16 16v235.888a16 16 0 0 0 16 16H496V720a16 16 0 0 0 32 0v-72.224h102.592a16 16 0 0 0 16-16V395.888a16 16 0 0 0-16-16zM409.408 615.776V411.888h205.168v203.888H409.408zM189.232 623.44c0.928 0.176 1.792 0.56 2.768 0.56h88.192a16 16 0 0 0 0-32H192c-0.976 0-1.84 0.384-2.768 0.56A47.84 47.84 0 0 0 144 560a48 48 0 1 0 0 96 47.84 47.84 0 0 0 45.232-32.56zM144 464a47.84 47.84 0 0 0 45.232-32.56c0.928 0.176 1.792 0.56 2.768 0.56h88.192a16 16 0 0 0 0-32H192c-0.976 0-1.84 0.384-2.768 0.56A47.84 47.84 0 0 0 144 368a48 48 0 1 0 0 96zM864 560a47.84 47.84 0 0 0-45.056 32H736a16 16 0 0 0 0 32h82.944A47.84 47.84 0 0 0 864 656a48 48 0 1 0 0-96zM818.944 400H736a16 16 0 0 0 0 32h82.944A47.84 47.84 0 0 0 864 464a48 48 0 1 0 0-96 47.84 47.84 0 0 0-45.056 32z",
    fill: "#49A3FE",
    "p-id": 2997
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M729.408 281.6H294.592a16 16 0 0 0-16 16v432.464a16 16 0 0 0 16 16h434.832a16 16 0 0 0 16-16V297.6c-0.016-8.832-7.168-16-16.016-16z m-16 70.64c-0.416-0.032-0.784-0.24-1.216-0.24H688a16 16 0 0 0 0 32h24.192c0.432 0 0.8-0.208 1.216-0.24v256.496c-0.416-0.048-0.784-0.256-1.216-0.256H688a16 16 0 0 0 0 32h24.192c0.432 0 0.8-0.208 1.216-0.24v42.304H310.592V672h17.6a16 16 0 0 0 0-32h-17.6V384h17.6a16 16 0 0 0 0-32h-17.6v-38.4h402.832v38.64zM448 256a16 16 0 0 0 16-16V144a16 16 0 0 0-32 0v96a16 16 0 0 0 16 16zM448 778.064a16 16 0 0 0-16 16v96a16 16 0 0 0 32 0v-96a16 16 0 0 0-16-16zM576 256a16 16 0 0 0 16-16V144a16 16 0 0 0-32 0v96a16 16 0 0 0 16 16zM576 778.064a16 16 0 0 0-16 16v96a16 16 0 0 0 32 0v-96a16 16 0 0 0-16-16z",
    fill: "#0F13AE",
    "p-id": 2998
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M896 128m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 2999
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128 128m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 3000
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128 896m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 3001
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M896 896m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 3002
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M448 80m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 3003
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M448 954.064m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 3004
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M576 80m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 3005
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M576 954.064m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#0F13AE",
    "p-id": 3006
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon13.51654cbc3b9898768fe4671f7f335ece.svg";
export { ForwardRef as ReactComponent };